import { ArrowRight, CalendarClock } from "lucide-react";

function PersistentTaskMockup() {
  return (
    <div className="bg-warm-bg-card border border-warm-border rounded-2xl shadow-soft-lg p-6 space-y-5">
      {/* Task with toggle enabled */}
      <div className="bg-warm-bg-base border border-warm-border rounded-lg p-3 space-y-3">
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 rounded border border-warm-border shrink-0" />
          <span className="text-sm font-medium text-warm-text-primary">
            📌 Pay parking ticket
          </span>
        </div>
        {/* Toggle row — ON state, matches the real TaskDialog styling */}
        <div className="flex items-center gap-3 px-3 py-2.5 rounded-soft bg-warm-blue/10 border border-warm-blue/30">
          <CalendarClock className="w-4 h-4 text-warm-blue shrink-0" />
          <div className="flex-1 min-w-0">
            <div className="text-xs font-medium text-warm-blue">Carry over</div>
            <div className="text-[10px] text-warm-text-tertiary leading-tight mt-0.5">
              Moves to today each day until it is done. The time stays the same.
            </div>
          </div>
          <div className="relative w-8 h-4 rounded-full bg-warm-blue shrink-0">
            <div className="absolute top-0.5 right-0.5 w-3 h-3 bg-white rounded-full shadow-sm" />
          </div>
        </div>
      </div>

      {/* Rollover visualization: Yesterday → Today */}
      <div className="flex items-stretch gap-3">
        {/* Yesterday */}
        <div className="flex-1 bg-warm-bg-elevated rounded-lg p-3 border border-warm-border-subtle">
          <div className="text-[9px] uppercase tracking-wider text-warm-text-tertiary font-medium mb-2">
            Yesterday
          </div>
          <div className="bg-warm-bg-base border border-warm-border-subtle rounded px-2 py-1.5 flex items-center gap-1.5">
            <div className="w-3 h-3 rounded border border-warm-border shrink-0" />
            <span className="text-[11px] text-warm-text-tertiary line-through">
              📌 Pay parking ticket
            </span>
          </div>
          <div className="text-[9px] text-red-500 dark:text-red-400 mt-1.5 ml-0.5">
            Not completed
          </div>
        </div>

        {/* Arrow */}
        <div className="flex items-center">
          <ArrowRight className="w-4 h-4 text-warm-blue" />
        </div>

        {/* Today */}
        <div className="flex-1 bg-warm-bg-elevated rounded-lg p-3 border border-warm-blue/30">
          <div className="text-[9px] uppercase tracking-wider text-warm-blue font-medium mb-2">
            Today
          </div>
          <div className="bg-warm-bg-base border border-warm-blue/30 rounded px-2 py-1.5 flex items-center gap-1.5">
            <div className="w-3 h-3 rounded border border-warm-border shrink-0" />
            <span className="text-[11px] text-warm-text-primary font-medium">
              📌 Pay parking ticket
            </span>
          </div>
          <div className="text-[9px] text-warm-blue mt-1.5 ml-0.5">
            Auto-rescheduled
          </div>
        </div>
      </div>
    </div>
  );
}

export default PersistentTaskMockup;
